module.exports = __webpack_public_path__ + "img/btn.387ffd83.png";